import redirector from "../../../util/redirector";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrSuccess, showToastrError } from "../../../util/toastr.js";
import moment from "moment";
import * as pageConstants from "../../../constants/EasterEggConstants";
import { AccountTypes, Landen, FederatieDropdown } from "../../../constants/DomainConstants";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import assign from 'object-assign';
import accountApi from "../../../api/shared/accountApi";
import contactApi from "../../../api/shared/contactApi";
import gemeenteApi from "../../../api/shared/gemeenteApi";
import tochtTypeApi from "../../../api/shared/tochtTypeApi";
import tochtApi from "../../../api/e-loket/tochtApi";
import cloneDeep from 'lodash/cloneDeep';

export default class TochtPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;

        const params = context.props.match.params;
        const cloneId = params.tochtId;
        ajaxActions.started();

        accountApi.getAccountsByAccounttype([AccountTypes.FEDERATIE, AccountTypes.KOEPELORGANISATIE])
            .then((response) => {
                ajaxActions.ended();
                this.processFederatieKoepelOrganisatieAccounts(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });

        ajaxActions.started();
        gemeenteApi.getHoofdgemeenten()
            .then((response) => {
                ajaxActions.ended();
                this.processHoofdgemeenten(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });

        ajaxActions.started();
        tochtTypeApi.getTochtTypes()
            .then((response) => {
                ajaxActions.ended();
                this.processTochtTypes(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });

        ajaxActions.started();
        this.loadKopieerbareTochten(ajaxActions);
        contactApi.getContactsByAccount().then((response) => {
            ajaxActions.ended();
            this.processContactpersonen(response);
        })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });

        ajaxActions.started();
        tochtApi.getLegeContactPersoon().then((response) => {
            ajaxActions.ended();
            this.processLegeContactpersoon(response);
        })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });


        ajaxActions.started();
        if (!cloneId) {
            tochtApi.getNieuw().then((response) => {
                ajaxActions.ended();
                this.processModel(response, null, null);
            })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }
        else {
            tochtApi.getClone(cloneId).then((response) => {
                ajaxActions.ended();
                this.processModel(response, cloneId, null);
            })
                .catch((ex) => {
                    ajaxActions.failed();
                    context.props.throwException(ex);
                });
        }

    }

    processFederatieKoepelOrganisatieAccounts(response) {
        const context = this.context;

        let model = (response.data.filter(account => account.accountType == AccountTypes.FEDERATIE || account.accountType == AccountTypes.KOEPELORGANISATIE)).map(k => { return { value: k.id, label: k.naam, tochtTypeId: k.tochtTypeId, tochtenAutomatischGoedkeuren: k.tochtenAutomatischGoedkeuren }; });

        context.setState({
            federatieEnKoepelOpties: model
        });
    }

    processHoofdgemeenten(response) {
        const context = this.context;

        let model = response.data.map(k => { return { value: k.hoofdaccountId, label: k.naam }; });

        context.setState({
            aangeslotenBijGemeente: model
        });
    }

    processTochtTypes(response) {
        const context = this.context;

        let model = response.data.map(k => { return { value: k.id, label: k.naam }; });

        context.setState({
            tochtTypes: model
        });
    }

    processContactpersonen(response) {
        const context = this.context;

        let list = response.data ? response.data.map(k => { return { value: k.id, label: k.voornaam + ' ' + k.naam }; }) : null;
        if (list) list.push({ value: "newContact", label: "Nieuwe contactpersoon" });

        context.setState({
            contactpersonenLabelValuePair: list,
            contactpersonen: response.data,
        });
    }

    processModel(response, fullCloneId, algemeneGegevensCloneId) {
        const context = this.context;

        const previousModel = context.state.model;

        let model = response.data;

        if (fullCloneId != null) {
            model.idToCloneFullTocht = fullCloneId;
        }

        let organisatorHadAlFederatie = model.aangeslotenBij != null;
        if (algemeneGegevensCloneId != null) {
            model.idToCloneAlgemeneGegevens = algemeneGegevensCloneId;
            model.tochtTypeId = previousModel.tochtTypeId;
            model.datum = null;
            model.aangeslotenBij = previousModel.aangeslotenBij;
            model.nietAangeslotenBij = previousModel.nietAangeslotenBij;
            model.viaFederatie = previousModel.viaFederatie;
            organisatorHadAlFederatie = context.state.organisatorHadAlFederatie;
        }

        let validationResults = null;
        let contactpersoon = model.contactpersoon && model.contactpersoon.isStored ? model.contactpersoon.id : "";

        context.setState({
            model,
            errors: validationResults,
            selectedContactpersoon: contactpersoon,
            organisatorHadAlFederatie
        });

        context.props.loadLayout('');
    }

    processLegeContactpersoon(response) {
        const context = this.context;

        let newContact = response.data;

        context.setState({
            newContact
        });
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = value;

        this.context.setState({
            model
        });
    }

    onDatumChange(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = value;

        const datum = moment(value, "YYYY-MM-DDTHH:mm", true);
        const showTeLaatPopup = datum.isValid() && datum.diff(moment(), 'days') < this.context.props.dagenNodigVoorMachtiging;

        this.context.setState({
            model,
            showTeLaatPopup
        });
    }

    confirmTeLaatPopup() {
        this.context.setState({
            showTeLaatPopup: false
        });
    }

    openKopieerGegevensTochtModal() {
        this.context.setState({
            kopieerModalIsOpen: true
        });
    }

    closeKopieerGegevensTochtModal() {
        this.context.setState({
            kopieerModalIsOpen: false
        });
    }

    onSelectTeKopierenTocht(selectedTochtId) {
        this.closeKopieerGegevensTochtModal();
        const tochtToClone = this.context.state.kopieerbareTochten.filter(x => x.id === selectedTochtId)[0];
        const tocht = cloneDeep(tochtToClone);
        tocht.startGemeente = null;
        const response = { data: tocht };
        this.processModel(response, null, tochtToClone.idToCloneAlgemeneGegevens);
    }
    onContactpersoonChange(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model.contactpersoon[property] = value;

        this.context.setState({
            model
        });
    }

    onNietAangeslotenBijChange(event) {
        const value = event.target.checked;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = value;

        if (event.target.checked)
            model.aangeslotenBij = null;

        this.context.setState({
            model
        });
    }

    onAangeslotenBijChange(event) {
        const value = event.target.value;

        const model = this.context.state.model;
        if (value === FederatieDropdown.NIET_AANGESLOTEN) {
            model.nietAangeslotenBij = true;
            model.aangeslotenBij = null;
        } else {
            model.nietAangeslotenBij = false;
            model.aangeslotenBij = value || null;
        }

        this.context.setState({
            model
        });
    }

    onTochtTypeChange(event) {
        const value = event.target.value || null;
        const context = this.context;
        const model = context.state.model;
        model.tochtTypeId = value;

        if (value && !model.organisatorIsFederatie && context.state.organisatorHadAlFederatie)
            model.viaFederatie = null;
        if (value && !model.organisatorIsFederatie && !context.state.organisatorHadAlFederatie)
            model.nietAangeslotenBij = false;

        this.updateTochtFederatie(model);

        context.setState({
            model
        });
    }

    updateTochtFederatie(model) {
        const { federatieEnKoepelOpties, organisatorHadAlFederatie } = this.context.state;
        const federatiesVoorTochtType = federatieEnKoepelOpties.filter(optie => optie.tochtTypeId === model.tochtTypeId);

        if (model.organisatorIsFederatie) {
            model.viaFederatie = !!model.tochtTypeId && federatiesVoorTochtType.some(optie => optie.value === model.organisatorId);
            return;
        }

        if (!organisatorHadAlFederatie) {
            if (model.tochtTypeId) {
                const gekozenFederatiePastBijTochtType = federatiesVoorTochtType.some(optie => optie.value === model.aangeslotenBij);
                if (federatiesVoorTochtType.length === 0 || (model.aangeslotenBij && !gekozenFederatiePastBijTochtType))
                    model.nietAangeslotenBij = federatiesVoorTochtType.length === 0;
                if (!gekozenFederatiePastBijTochtType)
                    model.aangeslotenBij = null;
            }
            model.viaFederatie = model.nietAangeslotenBij ? false : (model.aangeslotenBij ? true : null);
            return;
        }

        if (!model.tochtTypeId)
            return;

        const aangeslotenFederatieVoorTochtType = federatiesVoorTochtType.find(optie => optie.value === model.aangeslotenBij);
        if (!aangeslotenFederatieVoorTochtType || aangeslotenFederatieVoorTochtType.tochtenAutomatischGoedkeuren)
            model.viaFederatie = !!aangeslotenFederatieVoorTochtType;
    }

    onTochtNietViaFederatieChange(event) {
        const value = event.target.value;

        const model = this.context.state.model;
        model.viaFederatie = value === "true" ? false : (value === "false" ? true : null);

        this.context.setState({
            model
        });
    }

    loadKopieerbareTochten(ajaxActions) {
        const context = this.context;

        tochtApi.getKopieerbareTochtenByOrganisator()
            .then((response) => {
                // ajaxActions.ended();
                this.processKopieerbareTochten(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    processKopieerbareTochten(response) {
        this.context.setState({
            fetchedKopieerbareTochten: true,
            kopieerbareTochten: response.data
        });
    }

    onLandChange(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model[property] = value;

        if (model.startplaatsLand === Landen.BELGIE) {
            model.startplaatsGemeenteNietBelgie = null;
        }
        else {
            model.startplaatsPostcode = null;
        }

        this.context.setState({
            model
        });
    }

    onContactpersoonLandChange(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = this.context.state.model;
        model.contactpersoon[property] = value;

        if (model.contactpersoon.land === Landen.BELGIE) {
            model.contactpersoon.postcodeNietBelgie = null;
            model.contactpersoon.gemeenteNietBelgie = null;
        }
        else {
            model.contactpersoon.postcode = null;
            model.contactpersoon.gemeente = null;
        }

        this.context.setState({
            model
        });
    }

    onAddGemeente() {
        let gemeenten = this.context.state.model.gemeenten;

        gemeenten.push(null);

        this.context.setState({ model: Object.assign({}, this.context.state.model, { gemeenten: gemeenten }) });
    }

    onRemoveGemeente(index) {
        const model = this.context.state.model;

        model.gemeenten.splice(index, 1);

        this.context.setState({
            model
        });
    }

    onChangeGemeente(index, event) {
        const value = event.target.value;
        const model = this.context.state.model;

        this.context.state.model.gemeenten[index] = value;

        this.context.setState({
            model
        });
    }

    onChangeContactpersoonSelection(event) {
        const value = event.target.value;
        const model = this.context.state.model;

        if (value !== "newContact" && value !== "") {
            const contactpersonen = this.context.state.contactpersonen;

            const cp = contactpersonen.find(c => c.id === value);

            model.contactpersoon = cp;
            model.contactpersoon.isStored = true;

            if (!model.contactpersoon.land)
                model.contactpersoon.land = Landen.BELGIE;
        }
        else {
            const newContact = this.context.state.newContact;
            model.contactpersoon = Object.assign({}, newContact);
        }
        model.gekozenContactPersoon = value;
        this.context.setState({
            selectedContactpersoon: value,
            model
        });
    }

    annuleer() {
        this.redirector.goTo("/e-loket/organisatoroverzicht");
    }

    onSave() {
        const ajaxActions = this.context.props.ajaxActions;

        let errors = null;
        let context = this.context;
        let state = context.state;

        let model = state.model;

        this.updateTochtFederatie(model);

        ajaxActions.started();
        return tochtApi.saveTocht(model).then((response) => {
            ajaxActions.ended();
            if (response.statusText === "OK" && !response.data.hasValidationErrors) {
                showToastrSuccess(messages.MESSAGE_SAVED);
                redirector.goTo("/e-loket/organisator/" + model.id + "/false");
            } else {
                errors = assign({}, response.data.validationResults);
                model = assign({}, response.data.item, {});
                showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
            }

            this.context.setState({
                errors: errors,
                validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
                model,
                shouldScrollToFirstError: true
            });
        })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

}